class FilterGroup extends HTMLElement {
  constructor() {
    super();
    this.label = this.querySelector('.filter-group__header');
    this.filters = this.querySelector('.filter-group__options');
    this.label.addEventListener('click', this.toggleFilterGroup.bind(this));
  }

  toggleFilterGroup() {
    this.classList.toggle('filters-open');
  }
}
customElements.define('filter-group', FilterGroup);



class CollectionGrid extends HTMLElement {
  constructor() {
    super();
    this.filterContainer = this.querySelector('.product-filters');
    this.productContainer = this.querySelector('.product-container');
    this.filters = document.querySelectorAll('.filter_button');
    this.currentFilters = [];
    this.getProductData();
    this.products = []; // this is all the products in the collection
    this.currentProducts = []; // this is only the products that are currently being shown
    this.initiateFilters();
  }

  initiateFilters() {
    // add click listener to each filter in the filter menu
    for(var i = 0; i < this.filters.length; i++) {
      this.filters[i].addEventListener('click', this.updateFilters.bind(this));
    }
  }
  
  updateFilters(filter) {
    // make sure there is a tag value attached, otherwise it will treat it as a button with a link inside for main category pages
    if (filter.currentTarget.dataset.tag ) {
      this.classList.remove('show-filters');
      // check if filter is selected, if so remove filter, if not apply filter
      if ( filter.currentTarget.classList.contains('selected') ) {
        this.removeFilter(filter);
      } else {
        // gets new filter when clicked
        const newFilter = filter.currentTarget.dataset.tag;

        // adds or remove from list of all the filters 
        if ( this.currentFilters.includes(newFilter) ) {
        } else {
          filter.currentTarget.classList.add('selected');
          this.currentFilters.push(newFilter);
          // create and add button to remove filter
          const filterName = newFilter.split('_');
          var filterLink = `
          <a class="active-filter-button" data-filter="${newFilter}" href="${window.location}" aria-label="Click to remove ${filterName[1]}">
            ${filterName[1]}
            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" style="transform: translate(5px,-11px);" viewBox="0 0 29.25 29.25"><circle cx="14.5" cy="14.5" r="14.5" fill="#fff"></circle><g transform="translate(-3.375 -3.375)" opacity="0.7"><path d="M23.295,21.705,19.589,18l3.705-3.705a1.124,1.124,0,0,0-1.589-1.589L18,16.411l-3.705-3.705a1.124,1.124,0,0,0-1.589,1.589L16.411,18l-3.705,3.705a1.086,1.086,0,0,0,0,1.589,1.116,1.116,0,0,0,1.589,0L18,19.589l3.705,3.705a1.129,1.129,0,0,0,1.589,0A1.116,1.116,0,0,0,23.295,21.705Z"></path><path d="M18,5.344A12.651,12.651,0,1,1,9.049,9.049,12.573,12.573,0,0,1,18,5.344m0-1.969A14.625,14.625,0,1,0,32.625,18,14.623,14.623,0,0,0,18,3.375Z"></path></g></svg>
          </a>
          `
          // add this new filter link in two spots for mobile and desktop filters
          var desktopFilterLink = document.createElement('div');
          desktopFilterLink.innerHTML = filterLink;
          document.querySelector('.active-filters').appendChild(desktopFilterLink);
          desktopFilterLink.addEventListener('click', this.removeFilter.bind(this));

          
          var mobileFilterLink = document.createElement('div');
          mobileFilterLink.innerHTML = filterLink;
          document.querySelector('.applied-filters').appendChild(mobileFilterLink);
          mobileFilterLink.addEventListener('click', this.removeFilter.bind(this));
        }

        // and then calls the filtering function with the update list
        this.filterProducts();
      }
      
    } else {
      const filterLinkValue = filter.currentTarget.querySelector('a').href;
      window.location = filterLinkValue;
    }

  }

  filterProducts() {
    // looks through all the products for ones that match the current tag list
    // tags of the same category use an OR filter
    // tags from different categories use and AND filter
    // so if green, white, and small are selected, the product will match if it is
    // green OR white AND small
    
    const tags = this.currentFilters;
    
    // create new product list by filtering master list
    const newProductList = this.products.filter(checkTags);

    function checkTags(productObject) {
      const product = productObject.node;

      // first we group the tags into categories, so we can apply "and" logic to tags in the same category
      var tagCats = [];

      tags.forEach(function(tag) {
        const tagCategory = tag.split('_')[0];

        // check to see if the tag category exists
        const catIndex = tagCats.findIndex( tagCat => tagCat.category == tagCategory );

        // if the category index is found, check if the tag has already been added, if not add it
        if ( catIndex != -1 ) {
          if( !tagCats[catIndex].tags.includes( tag ) ) {
            tagCats[catIndex].tags.push(tag);
          }
        // if category index is not found, create a new category object and add it to tagCats array
        } else {
          const newTagCat = {
            category: tagCategory,
            tags: [
              tag
            ]
          }
          tagCats.push(newTagCat);
        }
      })

      // filtering here. start with assuming product matches
      var tagMatch = true;
      let sizesAvailable = false;
      // loop through each tag category
      tagCats.forEach(function(tagCat) {
        // added logic to remove products where the selected size is out of stock
        if ( tagCat.category == 'Size' ) {
          // loop through each selected size tag and look at product variants, if variant with that tag is out of stock, product not availble
          tagCat.tags.forEach(function(sizeTag) {
            const sizeTagValue = sizeTag.split('_')[1];
            product.variants.edges.forEach(function(variant) {
              const sizeOption = variant.node.selectedOptions.find( option => option.name == 'Size' )
              if ( sizeOption.value == sizeTagValue ) {
                if ( variant.node.quantityAvailable > 0 ) {
                  // if any of the selected size filters are available, this will set to true
                  // follows the AND logic structure
                  sizesAvailable = true;
                }
              }
            })
          })
          // if the tagMatch is already false, ignore size filter bc it doesn't match another category
          if (tagMatch != false) {
            tagMatch = sizesAvailable;
          }
        }
        // check if any of the tags on the product match a tag in the tag category, otherwise product will not match
        if( !product.tags.some(tag => tagCat.tags.includes(tag)) ) {
          tagMatch = false;
        }
      });
      return tagMatch;
    }
    
    // clear all the product cards
    this.clearProducts();

    // repopulate cards based on new list
    this.populateCards(newProductList);
    this.currentProducts = newProductList;
    this.populateTags();
  }

  clearProducts() {
    // clear all the product cards
    while(this.productContainer.firstChild) {
      this.productContainer.removeChild(this.productContainer.firstChild);
    }
  }

  removeFilter(evt) {
    evt.preventDefault();
    // get the filter value from the button or filter value
    var filterToRemove;
    if ( evt.currentTarget.querySelector('.active-filter-button') ) {
      filterToRemove = evt.currentTarget.querySelector('.active-filter-button').dataset.filter;
    } else {
      filterToRemove = evt.currentTarget.dataset.tag;
    }
    
    // remove it from filter array
    const newFilters = this.currentFilters.filter(filter => filter != filterToRemove);
    this.currentFilters = newFilters;

    // remove filter buttons from both spots, mobile and desktop
    document.querySelectorAll('.active-filter-button').forEach(function(button) {
      if ( button.dataset.filter == filterToRemove ) {
        button.remove();
      }
    })

    // remove selected class from filter element in menu
    this.filters.forEach(function(filter) {
      if ( filter.dataset.tag == filterToRemove ) {
        filter.classList.remove('selected');
      }
    })

    // resort collection
    this.filterProducts();
  }

  populateCards(products) {
    if( products.length > 0 ) {
      this.clearErrorMessage();
      const productContainer = this.productContainer;
      products.forEach(function(productObject) {
        const product = productObject.node;
        if ( product.availableForSale && product.images.edges.length > 0 ) {
          // need to rewrite this to piece together the new element based on what comes back from api, i.e. 1 or two images,
          // variant for sale or not for sale
          var newCard, productPrice, imageElement, cardBadge;
          // if product is on sale, display both prices and add sale badge
          var compareAtPrice = parseFloat(product.compareAtPriceRange.maxVariantPrice.amount).toFixed(2);
          var regPrice = parseFloat(product.variants.edges[0].node.price.amount).toFixed(2);
          let saleDifference = compareAtPrice - regPrice;
          let isSale;
          if (saleDifference > 0 ) {
            isSale = true;
          } else {
            isSale = false;
          }
          if ( isSale &&	compareAtPrice != 0.00  ) {
            productPrice = `<p class="product-price"><span class="strike-through">$${compareAtPrice}</span>&nbsp;&nbsp;$${regPrice}</p>`
            cardBadge = `<div class="card__badge"><span class="badge color-accent-2">Sale</span></div>`
          } else {
            productPrice = `<p class="product-price">$${regPrice}</p>`
            cardBadge = '';
          }

          const productTitle = product.title.split('-');
          // need to account for some products not having the second image. this catches that
          if ( product.images.edges[1] ) {
            newCard =
            `
            <div class="product-card_wrapper second-image">
              <figure class="product-card_image-container">
                <a class="hover-fade" href="${product.onlineStoreUrl}" aria-label="Go to ${product.title}">
                  <img class="product-card_image-1" src="${product.images.edges[0].node.lg}" loading="lazy" alt="Image of ${product.title}">
                  <img class="product-card_image-2" src="${product.images.edges[1].node.lg}" loading="lazy" alt="Image of ${product.title}">
                  ${cardBadge}
                </a>
              </figure>
              <h3 class="product-card_title">
                <a class="full-unstyled-link" href="${product.onlineStoreUrl}" aria-label="Go to ${product.title}">${productTitle[0]}</a>
              </h3>
              <p class="product-card_variant">
                <a class="full-unstyled-link" href="${product.onlineStoreUrl}" aria-label="Go to ${product.title}">${productTitle[1]}</a>
              </p>
              ${productPrice}
            </div>
            `
          } else {
            newCard =
            `
            <div class="product-card_wrapper">
              <figure class="product-card_image-container">
                <a class="hover-fade" href="${product.onlineStoreUrl}" aria-label="Go to ${product.title}">
                  <img class="product-card_image-1" src="${product.images.edges[0].node.lg}" loading="lazy" alt="Image of ${product.title}">
                  ${cardBadge}
                </a>
              </figure>
              <h3 class="product-card_title">
                <a class="full-unstyled-link" href="${product.onlineStoreUrl}" aria-label="Go to ${product.title}">${productTitle[0]}</a>
              </h3>
              <p class="product-card_variant">
                <a class="full-unstyled-link" href="${product.onlineStoreUrl}" aria-label="Go to ${product.title}">${productTitle[1]}</a>
              </p>
              ${productPrice}
            </div>
            `
          }
          
          var newCardElement = document.createElement('div');
          newCardElement.dataset.price = regPrice;
          newCardElement.dataset.name = product.title;
          newCardElement.dataset.date = product.publishedAt;
          newCardElement.classList.add('product-card');
          newCardElement.innerHTML = newCard;
          productContainer.appendChild(newCardElement);
        }
      })
    } else {
      this.displayErrorMessage();
    }
  }

  displayErrorMessage() {
    this.querySelector('.collection-message').style.display = 'block';
    this.querySelector('.collection-message').innerHTML = '<h2>Sorry, no products match your selected filters. Remove some filters to see more products.</h2>';
    this.productContainer.style.display = 'none';
  }

  clearErrorMessage() {
    this.querySelector('.collection-message').style.display = 'none';
    this.querySelector('.collection-message').innerHTML = '';
    this.productContainer.style.display = 'grid';
  }

  populateTags() {
    // group tags by category
    var allTags = [];

    // loop through all products and create a master list of tags
    this.currentProducts.forEach(function(product) {
      product.node.tags.forEach(function(tag) {
        // check if it is a filter tag - all include "_"
        if( tag.includes('_') ) {
          const tagCategory = tag.split('_')[0];
          const tagValue = tag.split('_')[1];

          // check to see if the tag category exists
          const catIndex = allTags.findIndex( tagCat => tagCat.category == tagCategory );

          // if the category index is found, check if the tag has already been added, if not add it
          if ( catIndex != -1 ) {
            if( !allTags[catIndex].tags.includes( tagValue ) ) {
              allTags[catIndex].tags.push(tagValue);
            }
          // if category index is not found, create a new category object and add it to allTags array
          } else {
            const newTagCat = {
              category: tagCategory,
              tags: [
                tagValue
              ]
            }
            allTags.push(newTagCat);
          }
        }
      })
    })
  }

  getProductData() {
    // fetches product data from shopify storefront API and stores it in the this.products array
    // fetches all products on initial page load
    const collection = this;
    const categoryHandle = this.querySelector('.collection-filter').dataset.handle;
    // here we separate out the tags that were included the URL
    const urlComponents = window.location.href.split(`${categoryHandle}/`);
    var collectionTags = [];
    if ( urlComponents[1] ) {
      collectionTags = urlComponents[1].split('+');
    }
    function apiCall(query) { 
      return fetch('https://jettylife.com/api/2022-04/graphql.json', 
        { 
          method: 'POST',
          headers: { 
            'Content-Type': 'application/graphql', 
            'X-Shopify-Storefront-Access-Token': "a41f5a82fd05f1ed4ff80274471283e2" 
          },
          "body": query 
        })
        .then(response => response.json()
      ); 
    }

    const el = this;

    async function fetchProductData() {
      // this loop will run until there are no more products to load
      var moreProducts = true;
      var endCursor = '';
      var pagination = '';
      while(moreProducts == true) {
        if(endCursor == '' ) {
          pagination = 'first: 100'
        } else {
          pagination = `first: 100, after: "${endCursor}"`
        }
        const query = `
        {
          collectionByHandle(handle: "${categoryHandle}") {
            products(${pagination}, filters: { available: true}) {
              edges {
                node {
                  title
                  tags
                  availableForSale
                  onlineStoreUrl
                  publishedAt
                  compareAtPriceRange {
                    maxVariantPrice {
                      amount
                    }
                  }
                  variants(first: 20) {
                    edges {
                      node {
                        price {
                          amount
                        }
                        quantityAvailable
                        selectedOptions {
                          name
                          value
                        }
                      }
                    }
                  }
                  images(first: 2) {
                    edges {
                      node {
                        lg: url(transform: {maxWidth: 800})
                        altText
                      }
                    }
                  }
                }
                cursor
              }
              pageInfo {
                hasNextPage
                endCursor
              }
            }
          }
        }
        `;
        const response = await apiCall(query);
        const currentProductBatch = el.products;
        var newProductBatch = response.data.collectionByHandle.products.edges;
        // filter by tags if they were included
        if ( collectionTags != [] ) {
          var allProductBatch = newProductBatch;
          newProductBatch = allProductBatch.filter( product => {
            var productMatch = true;
            const lowerCaseTags = product.node.tags.map(oldTag => {
              return oldTag.toLowerCase();
            })
            collectionTags.forEach(tag => {
              productMatch = lowerCaseTags.includes(tag.toLowerCase());
            })
            return productMatch;
          })
        }
        el.products = currentProductBatch.concat(newProductBatch);
  
        if(response.data.collectionByHandle.products.pageInfo.hasNextPage) {
          // continuously reload every 200 so you don't have to wait for all the products to be fetched, loads faster
          el.clearProducts();
          el.populateCards(el.products);
          el.currentProducts = el.products;
          endCursor = response.data.collectionByHandle.products.pageInfo.endCursor;
        } else {
          // stop loop when no more products are needed
          el.clearProducts();
          el.populateCards(el.products);
          el.currentProducts = el.products;
          moreProducts = false;
        }
      }
    }

    fetchProductData();
  }
}

customElements.define('collection-grid', CollectionGrid);